import { render } from "./FormNuevoTicketComponent.vue?vue&type=template&id=4c22921f&scoped=true"
import script from "./FormNuevoTicketComponent.vue?vue&type=script&lang=js"
export * from "./FormNuevoTicketComponent.vue?vue&type=script&lang=js"

import "./FormNuevoTicketComponent.vue?vue&type=style&index=0&id=4c22921f&scoped=true&lang=css"

import exportComponent from "/Users/daniel/Documents/CETECREA/cetecrea/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c22921f"]])

export default __exports__